import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon, ZapIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-ink-600 bg-ink-800" data-id="element-72" data-mp="3gfiyquovsxjx">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "19px",
      paddingBottom: "4px"
    }} data-id="element-73" data-mp="32nukolv2nz0b">
        <div className="flex flex-col items-center gap-6 text-center" data-id="element-74" data-mp="36oy0x9h17x22">
          <p className="flex items-center gap-2 font-display text-lg uppercase text-white" data-id="element-75" data-mp="36n3gdw9oa6yi">
            <ZapIcon className="h-5 w-5 text-ball-400" aria-hidden="true" data-id="element-76" data-mp="3ud7h9vvh7slt" />
            Sigma Smart™
          </p>

          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-77" data-mp="3lec768pb9yd8">
            <li data-id="element-78" data-mp="3qd6u9muba935">
              <a href="mailto:soporte.sigmasmart@gmail.com" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-79" data-mp="3qcnh0jflw8vg">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="2a1jk3b7gty3i" />
                soporte.sigmasmart@gmail.com
              </a>
            </li>
            <li data-id="element-81" data-mp="3lalhljipadw2">
              <a href="https://instagram.com/sigmasmartoficial" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-82" data-mp="3la29svmrl5vr">
                <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-83" data-mp="3v89dwdvyftgc" />
                @sigmasmartoficial
              </a>
            </li>
            <li data-id="element-84" data-mp="3q726wh1myyaq">
              <a href="https://www.sigmasmart.store" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-85" data-mp="3qaq1ljithqr1">
                <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="34p8v6p2nshq" />
                www.sigmasmart.store
              </a>
            </li>
          </ul>

          <p className="max-w-2xl text-xs leading-relaxed text-slate-600" data-id="element-87" data-mp="huo5h50zavv3">
            © Sigma Smart™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
            redistribución sin autorización expresa. Disponible para España y todos los países de
            habla hispana.
          </p>
        </div>
      </div>
    </footer>;
}